import {z as r} from 'zod';

import {LangKeyType} from '../../../provider/locale/translation/type';

export enum SsoLoginFormKeyEnum {
    ClientCode = 'clientCode',
}

export type SsoLoginFormType = {
    [SsoLoginFormKeyEnum.ClientCode]: string;
};

// The backend sends the browser back to this page with the refusal code when an SSO login fails.
export const ssoLoginErrorQueryName = 'sso_error';

// The registration page sends an SSO user here with the company code already known.
export const ssoLoginClientCodeQueryName = 'code';

// Refusal codes of the backend SSO login (rocketdata `SSODenyReason`).
export enum SsoLoginErrorEnum {
    ConfigNotFound = 'config_not_found',
    InvalidState = 'invalid_state',
    ProviderError = 'provider_error',
    InvalidToken = 'invalid_token',
    EmailMissing = 'email_missing',
    EmailTaken = 'email_taken',
    RoleNotMapped = 'role_not_mapped',
    UserBlocked = 'user_blocked',
    SiteMismatch = 'site_mismatch',
    EmailNotVerified = 'email_not_verified',
    LicenceLimit = 'licence_limit',
    InternalError = 'internal_error',
}

export const ssoLoginErrorLangKeyMap: Record<SsoLoginErrorEnum, LangKeyType> = {
    [SsoLoginErrorEnum.ConfigNotFound]: 'PAGE__SSO_LOGIN__ERROR__CONFIG_NOT_FOUND',
    [SsoLoginErrorEnum.InvalidState]: 'PAGE__SSO_LOGIN__ERROR__INVALID_STATE',
    [SsoLoginErrorEnum.ProviderError]: 'PAGE__SSO_LOGIN__ERROR__PROVIDER_ERROR',
    [SsoLoginErrorEnum.InvalidToken]: 'PAGE__SSO_LOGIN__ERROR__INVALID_TOKEN',
    [SsoLoginErrorEnum.EmailMissing]: 'PAGE__SSO_LOGIN__ERROR__EMAIL_MISSING',
    [SsoLoginErrorEnum.EmailTaken]: 'PAGE__SSO_LOGIN__ERROR__EMAIL_TAKEN',
    [SsoLoginErrorEnum.RoleNotMapped]: 'PAGE__SSO_LOGIN__ERROR__ROLE_NOT_MAPPED',
    [SsoLoginErrorEnum.UserBlocked]: 'PAGE__SSO_LOGIN__ERROR__USER_BLOCKED',
    [SsoLoginErrorEnum.SiteMismatch]: 'PAGE__SSO_LOGIN__ERROR__SITE_MISMATCH',
    [SsoLoginErrorEnum.EmailNotVerified]: 'PAGE__SSO_LOGIN__ERROR__EMAIL_NOT_VERIFIED',
    [SsoLoginErrorEnum.LicenceLimit]: 'PAGE__SSO_LOGIN__ERROR__LICENCE_LIMIT',
    [SsoLoginErrorEnum.InternalError]: 'PAGE__SSO_LOGIN__ERROR__UNKNOWN',
};

// Mirrors the backend `SSOConfig.slug`: a Django SlugField of at most 64 characters.
export const ssoClientCodeMaxLength = 64;
export const ssoClientCodePattern = /^\s*[\w-]+\s*$/;

export const ssoClientCodeStorageKey = 'ssoClientCode';
export const ssoClientCodeStorageSchema = r.string();
